// Takes content retrieved from Seo data lookup DB
// and pushes content to data layer

$(function () {
  window.dataLayer = window.dataLayer || [];
  const seoFields = {
    url: 'none',
    subject: 'none',
    vt_type: 'none',
    location: 'none',
    page_type: 'none',
    segment: 'none'
  };

  $.each(seoFields, function(field) {
    const metaTag = $(`meta[property='${field}']`).first();
    let metaTagValue;

    if (metaTag) {
      metaTagValue = metaTag.attr('content');
    }

    if (metaTagValue && metaTagValue.toLowerCase() !== 'nan') {
      seoFields[field] = metaTagValue;
    }
  });

  window.dataLayer.push({
    event: 'seoLookupEvent',
    url: seoFields['url'],
    subject: seoFields['subject'],
    vt_type: seoFields['vt_type'],
    location: seoFields['location'],
    page_type: seoFields['page_type'],
    segment: seoFields['segment']
  });
});
